import { APIServerURL, logAccess } from "../GlobalSettings";

//import Cookies from 'universal-cookie';

//const cookies = new Cookies();

export const auth = {
  login(email, pass, cb) {
    console.log("auth.login fired!");
    cb = arguments[arguments.length - 1];
    //console.log('Cookies: ' + cookies.getAll());
    //if (cookies.get('token') && cookies.get('tokenexpires') > Date.now()) {
    if (
      localStorage.getItem("token") &&
      Date.parse(localStorage.getItem("tokenexpires")) > Date.now()
    ) {
      if (cb) cb(true);
      this.onChange(true);
      return;
    }

    authRequest(email, pass, (res) => {
      if (res.authenticated === true) {
        console.log("res.token:" + res.token);
        console.log("res.UserInfo:");
        console.log(res.userinfo);

        /*var options = { path: '/', secure: false }
                cookies.set('token', res.token, options);
                cookies.set('tokenexpires',res.tokenexpires, options);
                cookies.set('email', res.email, options);
                cookies.set('userinfo', res.userinfo, options);*/

        setLocalStorage(res);

        if (cb) cb(true);
        this.onChange(true);
      } else {
        if (cb) cb(false);
        this.onChange(false);
      }
      console.log("auth.login exited!" + res.authenticated);
    });
  },

  updateUserInfo(userInfo) {
    //console.log('auth.updateuserInfo: '); console.log(userInfo);
    /*if (userInfo) {
            var options = {path: '/', secure: false};
        }*/
    //cookies.set('userinfo', userInfo, options);
    localStorage.setItem("userinfo", JSON.stringify(userInfo));
  },

  getUserActions() {
    var userInfo = JSON.parse(localStorage.getItem("userinfo"));
    // console.log("Userinfo: ", userInfo);
    if (userInfo !== undefined && userInfo.UserActionsList !== undefined)
      return userInfo.UserActionsList;
    else if (
      userInfo !== undefined &&
      userInfo.UserRoleBasedActions !== undefined
    ) {
      var ActionsList = {
        Navigation: {
          HomePage: true,
          Dashboard: false,
          ContentCatalog: false,
          Search: false,
        },
        Content: {
          ScheduleEvent: false,
          ViewDocument: false,
          PlayVideo: false,
          Download: false,
          Add: false,
          Edit: false,
          Delete: false,
          Review: false,
          Compliance: false,
          Publish: false,
          Yammer: false,
        },
        Equipment: {
          Add: false,
          Edit: false,
          Enable: false,
          Schedule: false,
          Delete: false,
        },
        Media: { Add: false, Edit: false, Enable: false, Delete: false },
        Metadata: { Add: false, Edit: false, Enable: false, Delete: false },
        Taxonomy: { Add: false, Edit: false, Enable: false, Delete: false },
        User: { Edit: false, Enable: false, Delete: false },
        Admin: { EditSystemSettings: false, ImpersonateUser: false },
        Role: { Add: false, Edit: false, Enable: false, Delete: false },
        Event: { Add: false, Edit: false, Approve: false, Delete: false },
        ContentCenter: { Add: false, Edit: false, Delete: false },
        EventDashboard: { Edit: false, Approve: false, Delete: false },
      };

      var userRBA = userInfo.UserRoleBasedActions;

      if (userRBA !== undefined) {
        userRBA.forEach(function (role) {
          switch (role.ActionID) {
            case "1":
              ActionsList.Content.Add = true;
              break;
            case "2":
              ActionsList.Content.Edit = true;
              break;
            case "3":
              ActionsList.Content.Review = true;
              break;
            case "4":
              ActionsList.Content.Compliance = true;
              break;
            case "5":
              ActionsList.Content.Publish = true;
              break;
            case "6":
              ActionsList.Content.Delete = true;
              break;
            case "7":
              ActionsList.Equipment.Add = true;
              break;
            case "8":
              ActionsList.Equipment.Edit = true;
              break;
            case "9":
              ActionsList.Equipment.Delete = true;
              break;
            case "10":
              ActionsList.Equipment.Enable = true;
              break;
            case "11":
              ActionsList.Equipment.Schedule = true;
              break;
            case "12":
              ActionsList.Event.Add = true;
              break;
            case "13":
              ActionsList.Event.Edit = true;
              break;
            case "14":
              ActionsList.Event.Delete = true;
              break;
            case "15":
              ActionsList.Event.Publish = true;
              break;
            case "16":
              ActionsList.Event.Approve = true;
              break;
            case "17":
              ActionsList.Event.Approve = true;
              break;
            case "18":
              ActionsList.Metadata.Add = true;
              break;
            case "19":
              ActionsList.Metadata.Edit = true;
              break;
            case "20":
              ActionsList.Metadata.Enable = true;
              break;
            case "21":
              ActionsList.Metadata.Delete = true;
              break;
            case "22":
              ActionsList.Taxonomy.Add = true;
              break;
            case "23":
              ActionsList.Taxonomy.Edit = true;
              break;
            case "24":
              ActionsList.Taxonomy.Enable = true;
              break;
            case "25":
              ActionsList.Taxonomy.Delete = true;
              break;
            case "26":
              ActionsList.Admin.EditSystemSettings = true;
              break;
            case "27":
              ActionsList.User.Edit = true;
              break;
            case "28":
              ActionsList.User.Enable = true;
              break;
            case "29":
              ActionsList.User.Delete = true;
              break;
            case "30":
              ActionsList.Role.Add = true;
              break;
            case "31":
              ActionsList.Role.Edit = true;
              break;
            case "32":
              ActionsList.Role.Enable = true;
              break;
            case "33":
              ActionsList.Role.Delete = true;
              break;
            case "34":
              ActionsList.Admin.ImpersonateUser = true;
              break;
            case "35":
              ActionsList.Event.Add = true;
              break;
            case "36":
              ActionsList.Event.Edit = true;
              break;
            case "37":
              ActionsList.Event.Delete = true;
              break;
            case "38":
              ActionsList.Content.ScheduleEvent = true;
              break;
            case "39":
              ActionsList.Content.ViewDocument = true;
              break;
            case "40":
              ActionsList.Content.PlayVideo = true;
              break;
            case "41":
              ActionsList.Navigation.HomePage = true;
              break;
            case "42":
              ActionsList.Navigation.Dashboard = true;
              break;
            case "43":
              ActionsList.Navigation.ContentCatalog = true;
              break;
            case "44":
              ActionsList.Navigation.Search = true;
              break;
            case "45":
              ActionsList.Content.Download = true;
              break;
            case "46":
              ActionsList.Content.CartDownload = true;
              break;
            case "47":
              ActionsList.ContentCenter.Add = true;
              break;
            case "48":
              ActionsList.ContentCenter.Edit = true;
              break;
            case "49":
              ActionsList.ContentCenter.Delete = true;
              break;
            case "50":
              ActionsList.EventDashboard.Edit = true;
              break;
            case "51":
              ActionsList.EventDashboard.Approve = true;
              break;
            case "52":
              ActionsList.EventDashboard.Delete = true;
              break;
            case "53":
              ActionsList.Content.Yammer = true;
              break;
          }
        });
      }

      userInfo.UserActionsList = ActionsList;
      this.updateUserInfo(userInfo);
      return ActionsList;
    }
  },

  getToken() {
    //return cookies.get('token');
    return localStorage.getItem("token");
  },

  isAuthenticated() {
    return localStorage.getItem("authenticated");
  },
  getImage() {
    return localStorage.getItem("userimgData");
  },
  logout(cb) {
    var token = this.getToken();
    removeLocalStorage();
    logout(token);
    ////this.onChange(false)
  },

  getUserEmail() {
    //console.log('auth.getUserEmail started');
    //return cookies.get('userinfo');
    return localStorage.getItem("email");
  },

  getUserInfo() {
    //console.log('auth.getUserInfo fired');
    if (localStorage.getItem("userinfo")) {
      if (!JSON.parse(localStorage.getItem("userinfo")).UserActionsList)
        this.getUserActions();
      return JSON.parse(localStorage.getItem("userinfo"));
    }
  },

  loggedIn() {
    if (
      localStorage.getItem("token") !== undefined &&
      parseInt(localStorage.getItem("tokenexpires"), 10) > Date.now()
    )
      return true;
    else return false;
  },

  userNeedsAdmin() {
    var UserActions = this.getUserActions();

    if (
      UserActions.Content.Add ||
      UserActions.Content.Edit ||
      UserActions.Content.Delete ||
      UserActions.Content.Review ||
      UserActions.Content.Compliance ||
      UserActions.Content.Publish ||
      UserActions.Equipment.Add ||
      UserActions.Equipment.Edit ||
      UserActions.Equipment.Delete ||
      UserActions.Equipment.Enable ||
      UserActions.Equipment.Schedule ||
      UserActions.Media.Add ||
      UserActions.Media.Edit ||
      UserActions.Media.Enable ||
      UserActions.Media.Delete ||
      UserActions.Metadata.Add ||
      UserActions.Metadata.Edit ||
      UserActions.Metadata.Enable ||
      UserActions.Metadata.Delete ||
      UserActions.Taxonomy.Add ||
      UserActions.Taxonomy.Edit ||
      UserActions.Taxonomy.Enable ||
      UserActions.Taxonomy.Delete ||
      UserActions.User.Edit ||
      UserActions.User.Enable ||
      UserActions.User.Delete ||
      UserActions.Admin.EditSystemSettings ||
      UserActions.Admin.ImpersonateUser ||
      UserActions.Role.Add ||
      UserActions.Role.Edit ||
      UserActions.Role.Enable ||
      UserActions.Role.Delete
    )
      return true;
    else return false;
  },

  verifyToken(activityOccurred) {
    // console.log('VerifyToken fired!');
    if (!this.loggedIn()) {
      return false;
    } else if (
      activityOccurred &&
      parseInt(localStorage.getItem("tokenexpires"), 10) <
        Date.now() + 29 * 60 * 1000
    ) {
      // user activity and < 29 minutes remaining...renew token
      //console.log("VerifyToken:")
      renewToken(this.getToken(), (res) => {
        if (res.authenticated === true) {
          //console.log('renew.token:' + res.token);
          //console.log('renew.UserInfo:'); console.log(res.userinfo);

          setLocalStorage(res);

          return true;
        } else {
          return false;
        }
        //console.log('auth.login exited!' + res.authenticated);
      });
    } else if (
      parseInt(localStorage.getItem("tokenexpires"), 10) <
      Date.now() + 5 * 60 * 1000
    ) {
      // if token will expire in 5 minutes
      //  console.log("TOKEN EXPIRING withing 5 minutes!!!!");
      return false;
    }

    //console.log("Token not expiring.");
    return true;
  },

  onChange() {},

  loginHPEPartner(token, cb) {
    //console.log('auth.loginhpepartner fired!');
    cb = arguments[arguments.length - 1];

    hpePartnerAuthRequest(token, (res) => {
      console.log("res.token:" + res.token);
      console.log("res.UserInfo" + res.userinfo);

      if (res.authenticated === true) {
        //var options = { path: '/', secure: false }
        /*cookies.set('token', res.token, options);
            cookies.set('tokenexpires',res.tokenexpires, options);
            cookies.set('email', res.email, options);
            cookies.set('userinfo', res.userinfo, options);*/

        setLocalStorage(res);

        if (cb) cb(true);
      } else {
        if (cb) cb(false);
      }
      //console.log('auth.loginhpepartner exited!' + res.authenticated);
    });
  },

  loginHPEPassport(email, pass, cb) {
    //console.log('auth.loginHPEPassport fired!');
    cb = arguments[arguments.length - 1];
    //console.log('Cookies: ' + cookies.getAll());

    hpePassportAuthRequest(email, pass, (res) => {
      //pretendRequest(email, pass, (res) => {
      //  console.log('res:', res);

      if (res.authenticated === true) {
        /*var options = { path: '/', secure: false }
                cookies.set('token', res.token, options);
                cookies.set('tokenexpires',res.tokenexpires, options);
                cookies.set('email', res.email, options);
                cookies.set('userinfo', res.userinfo, options);*/

        setLocalStorage(res);

        if (cb) cb(true);
        this.onChange(true);
      } else {
        if (cb) cb(false);
        this.onChange(false);
      }
      //console.log('auth.loginHPEPassport exited!' + res.authenticated);
    });
  },

  hpeUIDLogin(token, cb) {
    //console.log('auth.hpeuidlogin fired!');
    cb = arguments[arguments.length - 1];

    hpeUIDAuthRequest(token, (res) => {
      //  console.log('res.token:' + res.token);
      //console.log('res.UserInfo: ', res.userinfo);

      if (res.authenticated === true) {
        /*var options = { path: '/', secure: false }
                cookies.set('token', res.token, options);
                cookies.set('tokenexpires',res.tokenexpires, options);
                cookies.set('email', res.email, options);
                cookies.set('userinfo', res.userinfo, options);*/

        setLocalStorage(res);

        if (cb) cb(true);
        this.onChange(true);
      } else {
        if (cb) cb(false);
        this.onChange(false);
      }
      //console.log('auth.hpeuidlogin exited!' + res.authenticated);
    });
  },

  setNewLocalStorage(res) {
    localStorage.setItem("authenticated", res.authenticated);
    localStorage.setItem("token", res.token);
    localStorage.setItem("tokenexpires", res.tokenexpires);
    localStorage.setItem("email", res.email);
    localStorage.setItem("userinfo", JSON.stringify(res.userinfo));
    localStorage.setItem("userimgData", res.usrimgdata);
    localStorage.setItem("userOktaIDtoken", res.oktaIdtoken);
  },

  setBannerMsginStorage(msg) {
    localStorage.setItem("bannermsg", msg);
  },

  getBannerMsgInStorage() {
    return localStorage.getItem("bannermsg");
  },

  setRecentEvtsMMPopUpCounter(msg) {
    localStorage.setItem("recentpopup", msg);
  },

  getRecentEvtsMMPopUpCounter() {
    return localStorage.getItem("recentpopup");
  },
  setSearchParam(param) {
    localStorage.setItem("search", param);
  },

  setSearchDemoIdParam(param) {
    localStorage.setItem("demoid", param);
  },

  setNotificationCounter(param) {
    localStorage.setItem("notificationcounter", param);
    var d = new Date().setDate(new Date().getDate() + 1);
    localStorage.setItem("noticecounterdateexp", d);
  },

  getNoticeCounter() {
    return localStorage.getItem("notificationcounter");
  },

  getNoticeCounterDatelimit() {
    return localStorage.getItem("noticecounterdateexp");
  },

  getSearchParam() {
    return localStorage.getItem("search");
  },

  getSearchdemoidParam() {
    return localStorage.getItem("demoid");
  },

  setT1CategoryParam(param) {
    localStorage.setItem("t1name", param);
  },

  getT1CategoryParam() {
    return localStorage.getItem("t1name");
  },

  removeT1CategoryParam() {
    localStorage.removeItem("t1name");
  },

  setT2CategoryParam(param) {
    localStorage.setItem("t2name", param);
  },

  getT2CategoryParam() {
    return localStorage.getItem("t2name");
  },

  removeT2CategoryParam() {
    localStorage.removeItem("t2name");
  },

  setProdParam(param) {
    localStorage.setItem("prod", param);
  },

  getProdParam() {
    return localStorage.getItem("prod");
  },

  removeProdParam() {
    localStorage.removeItem("prod");
  },

  tokenExpiresNever(start) {
    if (!this.loggedIn()) {
      return false;
    } else if (start) {
      localStorage.setItem("tokenexpires", Date.now() + 5 * 60 * 60 * 1000);
    } else if (!start) {
      renewToken(this.getToken(), (res) => {
        if (res.authenticated === true) {
          setLocalStorage(res);
          return true;
        } else {
          return false;
        }
        //console.log('auth.login exited!' + res.authenticated);
      });
    }
  },
};

function setLocalStorage(res) {
  localStorage.setItem("token", res.token);
  localStorage.setItem("tokenexpires", res.tokenexpires);
  localStorage.setItem("email", res.email);
  localStorage.setItem("userinfo", JSON.stringify(res.userinfo));
}

function removeLocalStorage() {
  localStorage.removeItem("token");
  localStorage.removeItem("tokenexpires");
  localStorage.removeItem("email");
  localStorage.removeItem("userinfo");
  localStorage.removeItem("authenticated");
  localStorage.removeItem("userimgData");
  localStorage.removeItem("userOktaIDtoken");
  localStorage.removeItem("recentpopup");
}

function renewToken(token, cb) {
  //var that = this;
  //Edit in GlobalSettings to switch to different endpoint URL
  var url = APIServerURL + "/Account/RenewToken";

  var myInit = {
    method: "GET",
    mode: "cors",
    cache: "default",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
    },
  };

  fetch(url, myInit)
    .then(function (response) {
      if (response.ok) {
        if (response.status >= 400) {
          throw new Error("Bad response from server 400");
        }
        return response.json();
      } else {
        //console.log("Response not OK: " + response.status + " - " + response.statusText);
        cb({ authenticated: false });
        //throw new Error("Response not OK: " + response.status + " - " + response.statusText);
      }
    })
    .then(function (data) {
      //console.log(data);
      //if(data.authenticated === true) {
      let expiresDateMilliseconds = Date.now() + data.expires_in * 1000;
      //console.log('Expire Date:' + expiresDateMilliseconds);

      cb({
        authenticated:
          data.access_token === "Invalid Access" ? "Invalid Renew Token" : true,
        token: data.access_token,
        email: data.email,
        tokenexpires: expiresDateMilliseconds,
        userinfo: data.UserInfo,
      });
      //}
    })
    .catch((error) => {
      console.log("Error caught: " + error);
      cb({ authenticated: false });
    });
}

function authRequest(email, pass, cb) {
  // var that = this;
  //Edit in GlobalSettings to switch to different endpoint URL
  var url = APIServerURL + "/Account/authorize";

  let bodyStr = "username=" + encodeURIComponent(email);
  var myInit = {
    method: "POST",
    mode: "cors",
    cache: "default",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
      "Env-Key": "123456789ABCDE!@#$%",
    },
    body: bodyStr,
  };

  fetch(url, myInit)
    .then(function (response) {
      if (response.ok) {
        if (response.status >= 400) {
          throw new Error("Bad response from server 400");
        }
        return response.json();
      } else {
        //console.log("Response not OK: " + response.status + " - " + response.statusText);
        cb({ authenticated: false });
        //throw new Error("Response not OK: " + response.status + " - " + response.statusText);
      }
    })
    .then(function (data) {
      console.log(data);
      //if(data.authenticated === true) {
      let expiresDateMilliseconds = Date.now() + data.expires_in * 1000;
      //console.log('Expire Date:' + expiresDateMilliseconds);

      cb({
        authenticated:
          data.access_token === "Invalid Access"
            ? "Invalid User or Password"
            : true,
        token: data.access_token,
        email: data.email,
        tokenexpires: expiresDateMilliseconds,
        userinfo: data.UserInfo,
      });
      //}
    })
    .catch((error) => {
      console.log("Error caught: " + error);
      cb({ authenticated: false });
    });
}

function hpePartnerAuthRequest(token, cb) {
  //var that = this;
  //Edit in GlobalSettings to switch to different endpoint URL
  var url = APIServerURL + "/Account/authorizeHPEPRPToken";

  let bodyStr = "tokenId=" + encodeURIComponent(token);
  var myInit = {
    method: "POST",
    mode: "cors",
    cache: "default",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
    },
    body: bodyStr,
  };

  fetch(url, myInit)
    .then(function (response) {
      if (response.ok) {
        if (response.status >= 400) {
          throw new Error("Bad response from server 400");
        }
        return response.json();
      } else {
        //console.log("Response not OK: " + response.status + " - " + response.statusText);
        cb({ authenticated: false });
        //throw new Error("Response not OK: " + response.status + " - " + response.statusText);
      }
    })
    .then(function (data) {
      //console.log(data);
      //if(data.authenticated === true) {
      let expiresDateMilliseconds = Date.now() + data.expires_in * 1000;
      //console.log('Expire Date:' + expiresDateMilliseconds);

      cb({
        authenticated:
          data.access_token === null || data.access_token === "null"
            ? false
            : true,
        token: data.access_token,
        email: data.email,
        tokenexpires: expiresDateMilliseconds,
        userinfo: data.UserInfo,
      });
      //}
    })
    .catch((error) => {
      console.log("Error caught: " + error);
      //cb({authenticated: false})
    });
}

function hpePassportAuthRequest(email, pass, cb) {
  //var that = this;
  //Edit in GlobalSettings to switch to different endpoint URL
  var url = APIServerURL + "/Account/HPECustomerLogin";

  //let bodyJSON = { "Email" : encodeURIComponent(email), "Password" : encodeURIComponent(pass), "Usertype" : "3", "RememberMe" : false};
  let bodyJSON = {
    Email: email,
    Password: pass,
    Usertype: "3",
    RememberMe: false,
  };
  var myInit = {
    method: "POST",
    mode: "cors",
    cache: "default",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(bodyJSON),
  };

  fetch(url, myInit)
    .then(function (response) {
      if (response.ok) {
        if (response.status >= 400) {
          throw new Error("Bad response from server 400");
        }
        return response.json();
      } else {
        //console.log("Response not OK: " + response.status + " - " + response.statusText);
        cb({ authenticated: false });
        //throw new Error("Response not OK: " + response.status + " - " + response.statusText);
      }
    })
    .then(function (data) {
      console.log("Data returned post Customer auth from ID Server", data);
      //if(data.authenticated === true) {
      let expiresDateMilliseconds = Date.now() + data.expires_in * 1000;
      //console.log('Expire Date:' + expiresDateMilliseconds);

      cb({
        authenticated:
          data.access_token === null || data.access_token === "Invalid Access"
            ? false
            : true,
        token: data.access_token,
        email: data.email,
        tokenexpires: expiresDateMilliseconds,
        userinfo: data.UserInfo,
      });
      //}
    })
    .catch((error) => {
      console.log("Error caught: " + error);
      //cb({authenticated: false})
    });
}

function hpeUIDAuthRequest(token, cb) {
  //var that = this;
  //Edit in GlobalSettings to switch to different endpoint URL
  var url = APIServerURL + "/Account/authorizeHPEUIDToken";

  let bodyStr = "hpeuidtoken=" + encodeURIComponent(token);
  var myInit = {
    method: "POST",
    mode: "cors",
    cache: "default",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
    },
    body: bodyStr,
  };

  fetch(url, myInit)
    .then(function (response) {
      if (response.ok) {
        if (response.status >= 400) {
          throw new Error("Bad response from server 400");
        }
        return response.json();
      } else {
        //console.log("Response not OK: " + response.status + " - " + response.statusText);
        cb({ authenticated: false });
        //throw new Error("Response not OK: " + response.status + " - " + response.statusText);
      }
    })
    .then(function (data) {
      //console.log(data);
      //if(data.authenticated === true) {
      let expiresDateMilliseconds = Date.now() + data.expires_in * 1000;
      //console.log('Expire Date:' + expiresDateMilliseconds);

      cb({
        authenticated:
          data.access_token === "Invalid HPEUID Token" ? false : true,
        token: data.access_token,
        email: data.email,
        tokenexpires: expiresDateMilliseconds,
        userinfo: data.UserInfo,
      });
      //}
    })
    .catch((error) => {
      console.log("Error caught: " + error);
      cb({ authenticated: false });
    });
}

function logout(token, cb) {
  logAccess(null, null, "Logout", "home", token);
  var url = APIServerURL + "/Account/uidlogout";
  var myInit = {
    method: "GET",
    mode: "cors",
    cache: "default",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
    },
  };

  fetch(url, myInit)
    .then((response) => {
      if (response.ok) {
        if (response.status >= 400) {
          throw new Error("Bad response from server 400");
        }
        return response.text();
      } else {
        throw new Error("Bad response from server ");
      }
    })
    .then((data) => {
      logoutfromO365(data);
    })

    .catch((error) => {
      console.log("Error caught: " + error);
    });
}

function logoutfromO365(url) {
  window.open(url, "_self");
}

export default auth;
